import React, { useEffect, useState } from 'react';
import './ARScanner.css';
import type { ARScannerProps } from '../../types/components';

export const ARScanner: React.FC<ARScannerProps> = ({ isVisible }) => {
    const frameSize = 280;
    const borderRadius = 12;
    const FADE_DURATION = 500;

    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [show, setShow] = useState(isVisible);
    const [fadeClass, setFadeClass] = useState(isVisible ? 'ar-scanner--visible' : 'ar-scanner--hidden');

    useEffect(() => {
        const updateVh = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        updateVh();

        const handleResize = () => {
            updateVh();
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            setShow(true);
            setTimeout(() => setFadeClass('ar-scanner--visible'), 10);
        } else {
            setFadeClass('ar-scanner--hidden');
            const timeout = setTimeout(() => setShow(false), FADE_DURATION);
            return () => clearTimeout(timeout);
        }
    }, [isVisible]);

    if (!show) return null;

    const { width, height } = dimensions;
    const x = width / 2 - frameSize / 2;
    const y = height / 2 - frameSize / 2;

    return (
        <div className={`ar-scanner ${fadeClass}`}>
            <svg
                className="ar-scanner__svg-mask"
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: 1,
                    pointerEvents: 'none',
                }}
            >
                <defs>
                    <mask id="ar-scanner-mask">
                        <rect x="0" y="0" width={width} height={height} fill="white" />
                        <rect
                            x={x}
                            y={y}
                            width={frameSize}
                            height={frameSize}
                            fill="black"
                            rx={borderRadius}
                            ry={borderRadius}
                        />
                    </mask>
                </defs>
                <rect
                    x="0"
                    y="0"
                    width={width}
                    height={height}
                    fill="rgba(0,0,0,0.3)"
                    mask="url(#ar-scanner-mask)"
                />
                <rect
                    x={x}
                    y={y}
                    width={frameSize}
                    height={frameSize}
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    rx={borderRadius}
                    ry={borderRadius}
                    className="ar-scanner__snake-frame"
                />
            </svg>
            <div className="ar-scanner__text">
                Наведите камеру на картину
            </div>
        </div>
    );
};
